import { render } from "./Attacker.vue?vue&type=template&id=4b53f8cb"
import script from "./Attacker.vue?vue&type=script&lang=js"
export * from "./Attacker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/Attacker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b53f8cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b53f8cb', __exports__)) {
    api.reload('4b53f8cb', __exports__)
  }
  
  module.hot.accept("./Attacker.vue?vue&type=template&id=4b53f8cb", () => {
    api.rerender('4b53f8cb', render)
  })

}


export default __exports__